var LOCATION_CLASSES = {
  Location: true,
  Site: true,
  Building: true,
  Level: true,
  Room: true
};

function isLocationRecord (record) {
  var className = record && record['@class'];
  return Boolean(className && (LOCATION_CLASSES[className] || /Room$/.test(className)));
}

function forOriginColumn (originColumn) {
  if (!(originColumn && originColumn['@rid'])) return 'Networks';

  var path = Array.isArray(originColumn.path) ? originColumn.path : [];
  for (var index = path.length - 1; index >= 0; index -= 1) {
    var record = path[index];
    if (isLocationRecord(record)) return 'Locations';
    if (record && record['@class'] === 'Dashboard') return 'Dashboards';
  }

  return 'Networks';
}

module.exports = {
  forOriginColumn: forOriginColumn,
  isLocationRecord: isLocationRecord
};
